export interface CurrentUserResponse {
  is_admin: boolean;
}

export function normalizeCurrentUserResponse(raw: unknown): CurrentUserResponse {
  const o = raw && typeof raw === "object" ? (raw as Record<string, unknown>) : {};
  const nested =
    o.data && typeof o.data === "object" ? (o.data as Record<string, unknown>) : {};

  const isAdminRaw = o.is_admin ?? o.isAdmin ?? nested.is_admin ?? nested.isAdmin;

  return {
    is_admin: isAdminRaw === true,
  };
}
